import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Input,
  Label,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import ErrorBoundary from '../ErrorBoundary';

const ShareTemplateModal = ({
  handleClose,
  handleConfirm,
  name,
  editKey,
}) => {
  const [nameValue, setNameValue] = useState(null);
  const [nameError, setNameError] = useState(null);

  const intl = useIntl();

  const handleConfirmWrapper = () => {
    setNameError(false);

    if (!nameValue || nameValue.length === 0) {
      setNameError(true);
    } else {
      handleConfirm(nameValue, editKey);
      handleClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleConfirmWrapper();
    }
  };

  useEffect(() => {
    setNameValue(name);
  }, [name]);

  return (
    <ErrorBoundary>
      <ModalHeader toggle={handleClose} className="modal-header-center">
        {editKey !== null ? intl.formatMessage({ defaultMessage: 'Edit template name' }) : intl.formatMessage({ defaultMessage: 'Add new template' })}
      </ModalHeader>
      <ModalBody>
        <div>
          <Label for="shareTemplateName">
            {intl.formatMessage({ defaultMessage: 'Name' })}
          </Label>
          <Input
            type="text"
            name="name"
            id="shareTemplateName"
            autoFocus
            value={nameValue || ''}
            onChange={e => setNameValue(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={intl.formatMessage({ defaultMessage: 'Template name' })}
          />
          {nameError && (
            <div className="invalid-feedback" style={{ display: 'block' }}>
              {intl.formatMessage({ defaultMessage: 'Please provide a valid name' })}
            </div>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          {intl.formatMessage({ defaultMessage: 'Close' })}
        </Button>
        <Button
          color="primary"
          onClick={handleConfirmWrapper}
          disabled={!nameValue || `${nameValue}`.trim() === ''}
        >
          {intl.formatMessage({ defaultMessage: 'Confirm' })}
        </Button>
      </ModalFooter>
    </ErrorBoundary>
  );
};

ShareTemplateModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  name: PropTypes.string,
  editKey: PropTypes.string,
};

ShareTemplateModal.defaultProps = {
  name: null,
  editKey: null,
};

export default ShareTemplateModal;
